// extracted by mini-css-extract-plugin
export var configurationSection = "_tm-0";